import { ExternalLink } from "lucide-react";
import { MouseEvent, ReactNode } from "react";
import { useEnv } from "@/core/env";
import { cn } from "@/core/utils/utils";

interface ServiceTitanIconLinkProps {
  url: string;
  label: string;
  stopPropagation?: boolean;
  /**
   * "button" renders a padded link with muted resting text and a hover
   * background; font size is inherited from context. Omitted, the link
   * renders bare, with no padding or hover background.
   */
  variant?: "button";
  className?: string;
  children?: ReactNode; // rendered inside the link, before the icon
}

export const ServiceTitanIconLink = ({
  url,
  label,
  stopPropagation = false,
  variant,
  className,
  children,
}: ServiceTitanIconLinkProps) => {
  const { serviceTitanBaseUrl } = useEnv();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
  };

  return (
    <a
      href={serviceTitanBaseUrl + url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      onClick={handleClick}
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5",
        {
          "rounded-md px-1.5 py-1 text-tertiary-text transition-colors hover:bg-gray-10 hover:text-primary-text":
            variant === "button",
          "ml-1.5 text-muted-foreground hover:text-foreground": !variant,
        },
        className,
      )}
    >
      {children}
      <ExternalLink className="h-3 w-3" />
    </a>
  );
};
